import React from 'react';
import _ from 'lodash';
import withClickOutsideOnOverlay from '../../../../hoc/withClickOutsideOnOverlay';
import PopupWrapper from '../../../components/Popup/PopupWrapper';
import PopupHeader from '../../../components/Popup/PopupHeader';
import PopupBody from '../../../components/Popup/PopupBody';
import PopupButtons from '../../../components/Popup/PopupButtons';
import PopupCancelButton from '../../../components/Popup/PopupCancelButton';
import PopupButton from '../../../components/Popup/PopupButton';

class SaveToLastConfirmPopup extends React.Component {
    save = () => {
        const { project, makeScriptsEditable, onClose } = this.props;
        let lastTag;

        lastTag = _.find(project.tags, { message: 'last' });

        if (lastTag) {
            makeScriptsEditable(project, project.stageTagId, lastTag.tagId);
            onClose();
        }
    }

    cancel = () => {
        this.props.onClose();
    }

    render() {
        const { oldVersion } = this.props;
        return (
            <PopupWrapper className="save-to-last-confirm-popup">
                <PopupHeader title="Confirm Saving" />
                <PopupBody>
                    <div className="save-to-last-confirm-popup_version">
                        Are you sure you want to replace the content in <b>Last</b> with <b>{oldVersion}</b>? This action will overwrite any existing edits in 'Last' and cannot be undone. Please confirm to proceed.
                    </div>
                    <PopupButtons>
                        <PopupCancelButton action={this.cancel} />
                        <PopupButton label="Confirm" action={this.save} />
                    </PopupButtons>
                </PopupBody>
            </PopupWrapper>
        );
    }
}

export default withClickOutsideOnOverlay(SaveToLastConfirmPopup);